var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Router } from "@lit-labs/router";
import { LitElement, html } from "lit";
import { customElement } from "lit/decorators.js";
import "./components/nav.component";
import "./components/toast.component";
import { Event } from "./models/enums";
import "./pages/admin";
import "./pages/anon_content";
import "./pages/anon_home";
import "./pages/anon_login";
import "./pages/anon_notfound";
import "./pages/anon_register";
import "./pages/anon_reset";
import "./pages/anon_reset_verification";
import "./pages/anon_update_email";
import "./pages/anon_verification";
import "./pages/link";
import "./pages/user_cards";
import "./pages/user_info";
import { DataStore } from "./services/datastore.service";
import { EventBus } from "./services/eventbus.service";
import { debounce } from "./utils/utils";
let AppIndex = class AppIndex extends LitElement {
    constructor() {
        super();
        this._width = 0;
        this.routes = new Router(this, [
            { path: "/", render: () => html `<app-home></app-home>` },
            { path: "/p/:title", render: (params) => html `<app-content .location=${{ params }}></app-content>` },
            { path: "/link/:id/:gid", render: (params) => html `<app-link .location=${{ params }}></app-link>` },
            { path: "/register", render: () => html `<app-register></app-register>` },
            { path: "/verification/:id/:randomized", render: (params) => html `<app-verification .location=${{ params }}></app-verification>` },
            { path: "/login", render: () => html `<app-login></app-login>` },
            { path: "/reset", render: () => html `<app-reset></app-reset>` },
            { path: "/reset/:id/:randomized", render: (params) => html `<app-reset-verification .location=${{ params }}></app-reset-verification>` },
            { path: "/update/:id/:randomized", render: (params) => html `<app-update-email .location=${{ params }}></app-update-email>` },
            { path: "/cards/:select", render: (params) => html `<app-cards .location=${{ params }}></app-cards>` },
            { path: "/admin", render: () => html `<app-admin></app-admin>` },
            { path: "/user", render: () => html `<app-user></app-user>` },
            { path: "/404", render: () => html `<app-notfound></app-notfound>` },
            { path: "/*", render: () => html `<app-notfound></app-notfound>` },
        ]);
        this.onlineListener = () => {
            this.datastore.online = true;
            this.datastore.addLog('network switched to online');
            this.eventbus.dispatchEvent(Event.RequestUpdate);
        };
        this.offlineListener = () => {
            this.datastore.online = false;
            this.datastore.addLog('network switched to offline');
            this.eventbus.dispatchEvent(Event.RequestUpdate);
        };
        this.shortcutListener = (e) => {
            if (e.key === "Escape") {
                this.eventbus.dispatchEvent(Event.Escape);
            }
        };
        this.visibilityListener = () => {
            if (document.visibilityState === "visible") {
                this.eventbus.dispatchEvent(Event.Wakeup);
            }
        };
        this.resizeListener = debounce(() => {
            this.datastore.addLog("window resized to " + window.innerWidth + " / " + window.innerHeight);
            if (this._width !== window.innerWidth) {
                this.eventbus.dispatchEvent(Event.Wakeup);
            }
        }, 250);
        this.datastore = DataStore.getInstance();
        this.eventbus = EventBus.getInstance();
    }
    createRenderRoot() {
        return this;
    }
    connectedCallback() {
        super.connectedCallback();
        document.addEventListener("visibilitychange", this.visibilityListener);
        window.addEventListener("keyup", this.shortcutListener);
        window.addEventListener("resize", this.resizeListener);
        window.addEventListener("online", this.onlineListener);
        window.addEventListener("offline", this.offlineListener);
        this.setupServiceworker();
    }
    disconnectedCallback() {
        window.removeEventListener("resize", this.resizeListener);
        window.removeEventListener("keyup", this.shortcutListener);
        window.removeEventListener("online", this.onlineListener);
        window.removeEventListener("offline", this.offlineListener);
        document.removeEventListener("visibilitychange", this.visibilityListener);
        super.disconnectedCallback();
    }
    setupServiceworker() {
        if (!("serviceWorker" in navigator))
            return;
        const registerSW = async () => {
            await navigator.serviceWorker.register("./service-worker.js");
            let refreshing = false;
            navigator.serviceWorker.addEventListener("controllerchange", () => {
                if (refreshing)
                    return;
                refreshing = true;
                this.datastore.reload();
            });
        };
        if (document.readyState === "complete") {
            registerSW();
        }
        else {
            window.addEventListener("load", registerSW, { once: true });
        }
    }
    firstUpdated() {
        this._width = window.innerWidth;
        this.datastore.addLog(`loggedin: ${this.datastore.loggedIn}`);
        this.datastore.addLog(`pathname: ${window.location.pathname}`);
        this.datastore.addLog(`current: ${this.datastore.currentPage}`);
        if (this.datastore.loggedIn) {
            this.datastore.redirect(this.datastore.currentPage);
        }
        else {
            this.datastore.redirect(window.location.pathname);
        }
    }
    render() {
        return html `
            <app-nav></app-nav>
            <div class="toast-container has-text-centered">
                <app-toast></app-toast>
            </div>
            <section class="main mt-4 mb-4">
                <div class="container p-4">
                    ${this.routes.outlet()}
                </div>
            </section>
        `;
    }
};
AppIndex = __decorate([
    customElement("app-index")
], AppIndex);
export { AppIndex };
//# sourceMappingURL=index.js.map